module.exports = __webpack_public_path__ + "img/dat.d00aa112.svg";